/**
 * Relay Mutation: Get Organizations With Unpaid Invoices
 * 
 * Fetches aggregated summary of all organizations that have unpaid invoices.
 * Returns organization names, invoice counts, and total amounts by currency.
 * 
 * Permission: Developer only
 * Created: 2025-12-07
 * Updated: 2025-12-07 20:02 - Fixed cache issue
 */

import Relay from 'react-relay';

export default class GetOrganizationsWithUnpaidInvoicesMutation extends Relay.Mutation {
	getMutation() {
		return Relay.QL`mutation { getOrganizationsWithUnpaidInvoices }`;
	}

	getVariables() {
		// mutationWithClientMutationId automatically wraps this in { input: {...}, clientMutationId: ... }
		// So we return empty object which becomes { input: {}, clientMutationId: "..." }
		return {};
	}

	getFatQuery() {
		return Relay.QL`
			fragment on GetOrganizationsWithUnpaidInvoicesPayload {
				organizations {
					organisationId
					organisationName
					registrationNumber
					organizationCount
					organizations {
						organisationId
						organisationName
						isBlocked
					}
					totalUnpaidCZK
					totalUnpaidEUR
					totalUnpaidOther
					totalUnpaidOtherCurrency
					invoiceCount
					oldestDueDate
					oldestDueDateOverdue
					oldestDueDateNotOverdue
					isBlocked
					totalOverdueCZK
					totalOverdueEUR
					totalOverdueOther
					totalNotOverdueCZK
					totalNotOverdueEUR
					totalNotOverdueOther
					invoiceCountOverdue
					invoiceCountNotOverdue
					totalUp30CZK
					total31to60CZK
					total61to90CZK
					totalOver90CZK
					totalUp30EUR
					total31to60EUR
					total61to90EUR
					totalOver90EUR
					totalUp30Other
					total31to60Other
					total61to90Other
					totalOver90Other
					invoiceCountUp30
					invoiceCount31to60
					invoiceCount61to90
					invoiceCountOver90
				}
			}
		`;
	}

	getConfigs() {
		return [{
			type: 'REQUIRED_CHILDREN',
			children: [
				Relay.QL`
					fragment on GetOrganizationsWithUnpaidInvoicesPayload {
						organizations {
							organisationId
							organisationName
							registrationNumber
							organizationCount
							organizations {
								organisationId
								organisationName
								isBlocked
							}
							totalUnpaidCZK
							totalUnpaidEUR
							totalUnpaidOther
							totalUnpaidOtherCurrency
							invoiceCount
							oldestDueDate
							oldestDueDateOverdue
							oldestDueDateNotOverdue
							isBlocked
							totalOverdueCZK
							totalOverdueEUR
							totalOverdueOther
							totalNotOverdueCZK
							totalNotOverdueEUR
							totalNotOverdueOther
							invoiceCountOverdue
							invoiceCountNotOverdue
							totalUp30CZK
							total31to60CZK
							total61to90CZK
							totalOver90CZK
							totalUp30EUR
							total31to60EUR
							total61to90EUR
							totalOver90EUR
							totalUp30Other
							total31to60Other
							total61to90Other
							totalOver90Other
							invoiceCountUp30
							invoiceCount31to60
							invoiceCount61to90
							invoiceCountOver90
						}
					}
				`
			]
		}];
	}
}
